import { c as _c } from "react/compiler-runtime";
import React from 'react';
import type { CircularProgressProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Zoom from '@mui/material/Zoom';
export function ZoomSpinner(t0) {
  const $ = _c(18);
  let props;
  let show;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      show,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = show;
    $[3] = t1;
  } else {
    props = $[1];
    show = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 18 : t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = show ? 1 : 0;
  const t4 = show ? `${size}px` : 0;
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = {
      ml: t3,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: t4,
      transition: _temp
    };
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      color: "inherit"
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== props || $[10] !== size) {
    t7 = <CircularProgress sx={t6} size={size} {...props} />;
    $[9] = props;
    $[10] = size;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <Box sx={t2}><Box sx={t5}>{t7}</Box></Box>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== show || $[16] !== t8) {
    t9 = <Zoom in={show}>{t8}</Zoom>;
    $[15] = show;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
function _temp(theme) {
  return theme.transitions.create(["width", "margin"], {
    duration: 400,
    easing: "cubic-bezier(0.4, 0, 0.2, 1)",
    delay: 0
  });
}